import { Theme } from "@mui/material/styles";

export const SizeStyles = (theme: Theme) => {
  return {
    sm: {
      fontSize: theme.fontSizes.sm,
      ".CustomSwitch": {
        width: "36px",
        height: "20px",

        ".MuiSwitch-switchBase": {
          left: "2px",

          ".MuiSwitch-thumb": {
            width: "16px",
            height: "16px",
          },

          "&.Mui-checked": {
            transform: "translateX(16px)",
          },
        },
      },
    },
    md: {
      fontSize: theme.fontSizes.md,
      ".CustomSwitch": {
        width: "42px",
        height: "22px",

        ".MuiSwitch-switchBase": {
          left: "2px",

          ".MuiSwitch-thumb": {
            width: "18px",
            height: "18px",
          },
        },
      },
    },
    lg: {
      fontSize: theme.fontSizes.lg,
      columnGap: theme.space._400,
      ".CustomSwitch": {
        width: "52px",
        height: "28px",

        ".MuiSwitch-switchBase": {
          left: "2px",

          ".MuiSwitch-thumb": {
            width: "24px",
            height: "24px",
          },

          "&.Mui-checked": {
            transform: "translateX(24px)",
          },
        },
      },
    },
  };
};
